export function getCompetitionsRoutes() {
  return [
    {
      path: "/competitions",
      name: "competitions",
      component: () => import(/* webpackChunkName: competitions-old-backend*/ "./components/CompetitionsOld.vue"),
    },
  ]
}
